import React from "react";
import { PeekTypography } from "@piiqtechnologies/ui-components";
export const CategoryCardSubTitle = ({ subTitle }) => {
    return (React.createElement(PeekTypography, { variant: "body1", color: "grey.400" }, subTitle));
};
export default CategoryCardSubTitle;
